module.exports = __webpack_public_path__ + "media/images/jamicons/eye-f-25a1807198bbed825112ea80ad1a458b.svg";